import { render, staticRenderFns } from "./ANxADxAdolescencePage.vue?vue&type=template&id=ef6cf402"
import script from "./ANxADxAdolescencePage.vue?vue&type=script&lang=js"
export * from "./ANxADxAdolescencePage.vue?vue&type=script&lang=js"
import style0 from "./ANxADxAdolescencePage.vue?vue&type=style&index=0&id=ef6cf402&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports